export const host = {
  DEV: "d-review-static.dev.digitaledge.cigna.com",
  QA: "t-review-static.test.digitaledge.cigna.com",
  PROD: "p-review-static.digitaledge.cigna.com",
  LOCAL: "localhost:3000",
  PRODLIVE: "reviews.cigna.com"
};

export const getbaseURL = () => {
  const devUrl =
    "https://d-digital2.dev.internal.digitaledge.cigna.com/pbc/reviews/customer/v1";
  const qaUrl =
    "https://a-digital2.test.internal.digitaledge.cigna.com/pbc/reviews/customer/v1";
  const prodUrl = "https://p-digital2.digitaledge.cigna.com/pbc/reviews/customer/v1";
  switch (window.location.host) {
    case host.DEV:
      return devUrl;
    case host.LOCAL:
      return prodUrl;

    case host.QA:
      return qaUrl;

    case host.PROD:
      return prodUrl;
      
    case host.PRODLIVE:
      return prodUrl
  }
};

export const baseUrl = getbaseURL();

// const BASE_URL = 'https://d-digital2.dev.internal.digitaledge.cigna.com/pbc/reviews/customer/v1'; 

// export default BASE_URL;
